import { ca, el, is } from 'date-fns/locale';

export const renderStatus = (data) => {
    const { objType, isIssue, isEInvoice, canceledDpmInvoice, canceled, canceledInvoice, canceledIssue, docType, actionType, total } = data;
    const status = data.status || data.invoiceStatus;
    // Hoa don
    if (objType === 13) {
        //vang TS
        if (docType == 'GoldJewelry') {
            if (status == 'O') {
                if (canceled) {
                    return 'Hủy chờ thanh toán';
                }
                return 'Chờ thanh toán';
            }
            if (status == 'CP') {
                if (isIssue && canceledInvoice && canceledIssue) {
                    return 'Hủy lần 2';
                }
                if (isIssue && !canceledInvoice && canceledIssue) {
                    return 'Hủy lần 1';
                }
                if (!isIssue && canceledInvoice && !canceledIssue) {
                    return 'Hủy đã thanh toán';
                }
                if (isIssue) {
                    return 'Đã trả vàng';
                }
                return 'Đã thanh toán';
            }
        }
        //vang TD
        if (docType == 'GoldExchange') {
            if (status == 'O') {
                if (canceled) {
                    return 'Hủy chờ thanh toán';
                }
                return 'Chờ thanh toán';
            }
            if (status == 'CP') {
                if (isIssue && canceledInvoice && canceledIssue) {
                    return 'Hủy lần 2';
                }
                if (isIssue && !canceledInvoice && canceledIssue) {
                    return 'Hủy lần 1';
                }
                if (!isIssue && canceledInvoice && !canceledIssue) {
                    return 'Hủy đã thanh toán';
                }
                if (isIssue) {
                    return 'Đã trả vàng';
                }
                return 'Đã thanh toán';
            }
        }
    }
    //mua hàng
    if (objType === 18) {
        //vang TS
        if (docType == 'GoldJewelry') {
            if (status == 'O1') {
                return 'Chờ thanh toán lần 1';
            }
            if (status == 'O') {
                if (canceled) {
                    return 'Hủy chờ thanh toán';
                }
                return 'Chờ thanh toán';
            }
            if (status == 'CP') {
                if (isIssue && canceledInvoice) {
                    return 'Hủy lần 2';
                }
                if (canceledInvoice) {
                    return 'Hủy lần 1';
                }
                return 'Đã thanh toán';
            }
            if (status == 'C' && canceled) {
                return 'Hủy';
            }
        }
        //vang TD
        if (docType == 'GoldExchange') {
            if (status == 'O') {
                if (canceled) {
                    return 'Hủy chờ thanh toán';
                }
                return 'Chờ thanh toán';
            }
            if (status == 'CP') {
                if (isIssue && canceledInvoice) {
                    return 'Hủy lần 2';
                }
                if (canceledInvoice) {
                    return 'Hủy lần 1';
                }
                return 'Đã thanh toán';
            }
        }
    }
    //doi tra
    if (objType === 19) { 
        //đổi trả hàng vts
        if (docType == 'GoldJewelry') {
            if (actionType == 'OUT') {
                if (status == 'O1') {
                    return 'Chờ thanh toán lần 1';
                }
                if (status == 'O') {
                    if (canceled) {
                        return 'Hủy chờ thanh toán';
                    }
                    return 'Chờ thanh toán';
                }
                if (status == 'CP') {
                    if (isIssue && canceledInvoice && canceledIssue) {
                        return 'Hủy lần 2';
                    }
                    if (isIssue && !canceledInvoice && canceledIssue) {
                        return 'Hủy lần 1(hủy trả vàng)';
                    }
                    if (!isIssue && canceled) {
                        return 'Hủy đã thanh toán';
                    }
                    if (isIssue) {
                        return 'Đã trả vàng';
                    }
                    return 'Đã thanh toán';
                }
                if (status == 'C' && canceled) {
                    return 'Hủy(chờ thanh toán 1)';
                }
            }
            if (actionType == 'IN') {
                if (status == 'O1') {
                    return 'Chờ thanh toán lần 1';
                }
                if (status == 'O') {
                    if (canceled) {
                        return 'Hủy chờ thanh toán';
                    }
                    return 'Chờ thanh toán';
                }
                if (status == 'CP') {
                    if (isIssue && canceledInvoice) {
                        return 'Hủy lần 2';
                    }
                    if (!isIssue && canceledInvoice && !canceled) {
                        return 'Hủy lần 1';
                    }
                    return 'Đã thanh toán';
                }
                if (status == 'C' && canceled) {
                    return 'Hủy(chờ thanh toán 1)';
                }
            }
        }
        //đổi trả hàng VTD
        if (docType == 'GoldExchange') {
            if (status == 'O') {
                if (canceled && total == 0) {
                    return 'Hủy đã thanh toán(total=0)';
                }
                if (canceled) {
                    return 'Hủy chờ thanh toán';
                }
                return 'Chờ thanh toán';
                
            }
            if (status == 'CP') {  
                if(!canceled && !canceledInvoice && !isIssue && !canceledIssue) {
                    return 'Đã thanh toán(khi có phiếu chi)';
                }
                if (canceled && canceledInvoice) {
                    return 'Hủy lần 2';
                }
                if (!canceled && canceledInvoice) {
                    return 'Hủy đã thanh toán';
                }
                if (total == 0) {
                    return 'Đã thanh toán';
                }      
                return 'Hủy';
            } 
        }
    }
    if (objType === 26) {
        //vang TS
        if (docType == 'GoldJewelry') {
            if (status == 'O') {
                return 'Chờ thanh toán';
            }
            if (actionType == 'Sale') {
                if (status == 'CP') {
                    if (isIssue && canceledIssue && !canceledInvoice) {
                        return 'Hủy lần 1 (hủy trả vàng)';
                    }
                    if (isIssue && canceledInvoice && canceledIssue) {
                        return 'Hủy lần 2 (hủy sau khi hủy trả vàng)';
                    }
                    if (isIssue && !canceledIssue && !canceledIssue) {
                        return 'Đã trả vàng';
                    }
                }
                if (status == 'KHD' && !canceled) {
                    return 'Cập nhật serial vào phiếu';
                }
            }
            if (status == 'KHD' && canceled) {
                if (canceled && canceledDpmInvoice) {
                    return 'Hủy cọc sau khi hủy cập nhật serial';
                }
                if (canceled && !canceledDpmInvoice) {
                    return 'Hủy cập nhật serial';
                }
            }
            if (status == 'DPM') {
                if (canceled && !isIssue) {
                    return 'Hủy đã đặt cọc';
                }
                return 'Đặt cọc';
            }
            if (status == 'CP') {
                if (!isIssue && canceled) {
                    return 'Đã hủy đã thanh toán';
                }
                if (!isIssue && !canceled) {
                    return 'Đã thanh toán';
                }
            }
            if (status == 'C' && canceled) {
                return 'Hủy chờ thanh toán';
            }
        }
        //vang TD
        if (docType == 'GoldExchange') {
            if (status == 'O') {
                if (canceled) {
                    return 'Hủy chờ thanh toán';
                }
                return 'Chờ thanh toán';
            }
            if (status == 'CP') {
                if (isIssue && canceledInvoice && canceledIssue) {
                    return 'Hủy lần 2';
                }
                if (isIssue && canceledIssue) {
                    return 'Hủy lần 1';
                }
                if (!isIssue && canceled) {
                    return 'Đã hủy đã thanh toán';
                }
                if (isIssue) {
                    return 'Đã trả vàng';
                }
                return 'Đã thanh toán';
            }
            if (status == 'DPM') {
                if (canceled) {
                    return 'Hủy đã đặt cọc';
                }
                return 'Đặt cọc';
            }
        }
    }
    if (objType === 20) {
        if (status == 'O') {
            return 'Thành công';
        }
    }
    if (objType === 27) {
        if (status == 'O') {
            return 'Thành công';
        }
    }
    if (objType === 67) {
        if (status == 'O') {
            return 'Yêu cầu điều chuyển';
        }
        if (status == 'CP') {
            return 'Thành công';
        }
        if (status == 'C') {
            return 'Hủy yêu cầu điều chuyển';
        }
    }
    //Bảo hành
    if (objType === 88) {
        if (status == 'O1') {
            return canceled ? 'Đã hủy' : 'Chờ thanh toán lần 1';
        }
        if (status == 'O') {
            return canceled ? 'Đã hủy' : 'Chờ thanh toán';
        }
        if (status == 'C') {
            return 'Đã hủy';
        }
        if (status == 'CP') {
            // canceledInvoice là terminal — không cần phân biệt isIssue (BE giữ isIssue=true để audit).
            // Cả 2 nhánh terminal (hủy trực tiếp từ "Đã thanh toán" hoặc qua Bước 2 từ "Hủy đã trả vàng")
            // đều hiển thị "Hủy đã thanh toán" cho thống nhất với filter label.
            if (canceledInvoice) {
                return 'Hủy đã thanh toán';
            }
            // PHẢI check canceledIssue TRƯỚC isIssue (BE giữ isIssue=true sau khi hủy trả vàng).
            if (canceledIssue) {
                return 'Hủy đã trả vàng';
            }
            if (isIssue) {
                return 'Đã trả hàng';
            }
            return 'Đã thanh toán';
        }
    }
    const statusMap = {
        20: 'Hoàn thành',
        27: 'Hoàn thành'
    };

    if (typeof statusMap[objType] === 'object') {
        return statusMap[objType][status] || '';
    }
    return statusMap[objType] || '';
};

/**
 * Giao dịch còn dở dang trong ca → chặn đóng ca. Nhận trực tiếp odoc (cùng shape với renderStatus).
 */
export const isPendingDoc = (odoc) => {
    if (!odoc) return false;
    const { status, objType, isIssue, canceled, canceledInvoice, canceledIssue, docType, actionType } = odoc;

    // Mua hàng (18): chỉ "Hủy lần 1" (CP + canceledInvoice) còn dở dang — tiền đã thu lại bằng
    // phiếu thu nhưng vàng chưa trả khách và tồn kho chưa hoàn, phải bấm tiếp "Trả vàng & hủy
    // phiếu" (ISSUE) mới về "Hủy lần 2". BC NXT kho chỉ sinh dòng xuất ngược khi isIssue=true.
    // "Hủy chờ thanh toán" (O + canceled) đã trừ tồn ngay lúc hủy → là trạng thái cuối.
    if (objType === 18) return status === 'CP' && !!canceledInvoice && !isIssue;

    if (status === 'C') return false;
    if (status === 'O' || status === 'O1') return !canceled;
    if (status !== 'CP') return false;
    if (![13, 19, 26, 88].includes(objType)) return false;
    if (canceledInvoice) return false;
    if (objType === 19) {
        // Chỉ chiều xuất đổi hàng cho khách (OUT, vàng TS) mới có bước cuối "Đã trả vàng".
        // Chiều nhận hàng vào và vàng TD kết thúc ở "Đã thanh toán" → không coi là dở dang.
        if (docType !== 'GoldJewelry' || actionType !== 'OUT') return false;
        // "Hủy đã thanh toán" của 19/OUT dùng cờ canceled (không phải canceledInvoice) → terminal.
        if (canceled && !isIssue) return false;
    }
    // Bảo hành "Hủy đã trả vàng" (88), bán hàng "Hủy lần 1" (13), đổi trả "Hủy lần 1 (hủy trả vàng)" (19):
    // canceledIssue=true nhưng chưa hủy invoice → thu ngân chưa hoàn tất hủy phiếu.
    if ([13, 19, 88].includes(objType) && canceledIssue) return true;
    return !isIssue;
};
